module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/rectangle-0-5aa127833b12a78e77194f687b22a2da.png";